import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { GlobalStyle } from "./styles/globalStyles";
import { theme } from "./styles/theme";
import { NewNavigation } from "./components/NewNavigation";
import { MainLayout } from "./layouts/MainLayout";
import { RecordCreate } from "./pages/RecordCreate";
import { RecordVerify } from "./pages/RecordVerify";
import { Scanner } from "./pages/Scanner";
import { Records } from "./pages/Records";
import { ToastProvider } from "./components/Toast";
import { SearchView } from "./pages/SearchView";
import { ManualRecordEntry } from "./pages/ManualRecordEntry";
import RecordDetailView from "./pages/RecordDetailView";

function App() {
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <ToastProvider>
          <GlobalStyle />
          <NewNavigation />
          <MainLayout>
            <Routes>
              {/* <Route path="/dashboard" element={<Dashboard />} /> */}
              <Route path="/" element={<SearchView />} />
              {/* <Route path="/record/add" element={<RecordCreate />} /> */}
              <Route path="/record/manual" element={<ManualRecordEntry />} />
              {/* <Route path="/record/verify" element={<RecordVerify />} /> */}
              <Route
                path="/record/:recordHash"
                element={<RecordDetailView />}
              />
              <Route path="/record/scanner" element={<Scanner />} />
              <Route path="/records" element={<Records />} />
            </Routes>
          </MainLayout>
        </ToastProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
